/**
 * Button component themable props.
 */
import { stringLiteralArray } from "../utils"

export default {
  appearances: stringLiteralArray([
    "default",
    "primary",
    "secondary",
    "destructive",
    "ghosted",
    "link",
    "muted-link"
  ])
}
